module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b6d4c95a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/audio-player.vue
// module id = 489
// module chunks = 18